import type { AnnouncementCategory, IAnnouncement } from "@dc-ireland/shared"

export const announcementCategoryStyles: Record<AnnouncementCategory, string> = {
  announcement: "bg-[#9e7e43]/15 text-[#9e7e43]",
  update: "bg-dc-primary-900/10 text-dc-primary-900",
  ministry: "bg-[#2d1a45]/10 text-[#2d1a45]",
  event: "bg-emerald-600/10 text-emerald-700",
  community: "bg-[#9e7e43]/15 text-[#9e7e43]",
  charity: "bg-rose-700/10 text-rose-800",
}

export const announcementCategoryLabels: Record<AnnouncementCategory, string> = {
  announcement: "Announcement",
  update: "Update",
  ministry: "Ministry",
  event: "Event",
  community: "Community",
  charity: "Charity",
}

export const parseAnnouncementCategories = (value?: string): string[] => {
  const parts = (value ?? "")
    .split(",")
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean)

  return parts.length > 0 ? parts : ["announcement"]
}

export const announcementTagStyle = (tag: string) =>
  announcementCategoryStyles[tag as AnnouncementCategory] ?? "bg-[#ebebeb] text-[#4a454f]"

export const announcementTagLabel = (tag: string) => {
  const known = announcementCategoryLabels[tag as AnnouncementCategory]
  if (known) return known

  return tag
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

export const defaultAnnouncements: IAnnouncement[] = [
  {
    slug: "year-of-the-eagle",
    title: "Welcome to the Year of the Eagle",
    excerpt:
      "This year we soar higher in faith, vision, and purpose. Join us every Sunday as we explore what it means to rise on wings like eagles.",
    body:
      "This year at Dominion City Ireland, we are embracing the Year of the Eagle — a season of soaring faith, sharpened vision, and bold purpose.\n\nJoin us every Sunday as we unpack what it means to rise on wings like eagles, walk in divine strength, and carry the gospel across Ireland and beyond.",
    category: "announcement",
    imageUrl: "/year-of-the-eagle-2026.png",
    featured: true,
    publishedAt: "2026-01-05",
    sortOrder: 0,
  },
  {
    slug: "new-cork-service-time",
    title: "Updated Cork Service Times",
    excerpt:
      "Our Cork chapter has refreshed service times to better serve the community. Check the new schedule before you visit.",
    category: "update",
    linkUrl: "/#our-locations",
    linkLabel: "View locations",
    publishedAt: "2026-02-18",
    sortOrder: 1,
  },
  {
    slug: "worship-team-auditions",
    title: "Worship Team Auditions Open",
    excerpt:
      "Do you carry a heart for worship? We're welcoming vocalists and musicians to serve on our Dublin worship team.",
    category: "ministry",
    linkUrl: "mailto:info@dominioncity.ie",
    linkLabel: "Get in touch",
    publishedAt: "2026-03-01",
    sortOrder: 2,
  },
  {
    slug: "faith-in-action",
    title: "Faith in Action",
    excerpt:
      "During Dominion Convention Ireland 2026, we shared hygiene care packs with 58 people experiencing homelessness in Dublin, in honour of Dr David Ogbueli's 58th birthday.",
    body: "During the Dominion Convention Ireland 2026, we carried out a hygiene-poverty outreach in Dublin city centre, distributing care packs to people experiencing homelessness.\n\nWe reached **58 people** in honour of our founder, **Dr David Ogbueli's 58th birthday** — a practical way to celebrate his life and legacy of service.\n\nAs we shared the care packs in the heart of the city, our hearts were heavy. We saw, up close, the reality many homeless people face — especially as winter approaches. Many will sleep on the streets in the cold, in need of warmth, blankets and practical support.\n\nThis experience has inspired us to do more.\n\nIf you would like to join us in reaching even more people with blankets, hygiene packs and practical care this winter, you can give here: https://www.dominioncity.ie/give\n\nIf you live in Dublin and would like to donate blankets, please bring them to church this Sunday at the **Crowne Plaza Hotel, Blanchardstown, from 10:00 AM to 12:00 PM**.\n\nTogether, we can bring hope, dignity and the love of Christ to those who need it most.\n\n#DominionConventionIreland2026 #DominionCity #SocialImpact #HygienePoverty #CommunityOutreach #FaithInAction #FaithLoveImpact #Dublin #Homelessness",
    category: "community,charity",
    imageUrl: "https://res.cloudinary.com/colenocks/image/upload/v1792444826/dc_ireland/faith-in-action-mvfrdb6f.jpg",
    linkLabel: "Read more",
    publishedAt: "2026-10-19",
    sortOrder: 1,
  },
]
